/**
 * Fetch an image source before actually rendering it
 * @param {String} src - The source to fetch
 * @returns {Promise<Boolean>}
 */
const fetchImage = ({ src }) =>
    new Promise((resolve) => {
        const image = new Image();
        image.src = src;

        image.onload = () => {
            resolve(true);
        };

        image.onerror = () => {
            resolve(false);
        };
    });

export default fetchImage;
